import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SITE_ASSETS } from "../mock";

export default function CTASection() {
  return (
    <section className="relative py-28 lg:py-36 overflow-hidden">
      <div className="absolute inset-0">
        <img src={SITE_ASSETS.hero.aerial} alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#1F1B17]/80"></div>
      </div>
      <div className="relative max-w-[1100px] mx-auto px-6 lg:px-12 text-center text-[#F5EFE6]">
        <div className="section-eyebrow text-[#B8893C] mb-6">Schedule a Site Visit</div>
        <h2 className="font-display text-4xl md:text-6xl leading-[1.05] tracking-[0.04em] headline-spaced">
          Step Into a <span className="italic text-[#B8893C]">Tamra</span> Address.
        </h2>
        <p className="mt-8 text-[#E8DCC4] max-w-xl mx-auto leading-relaxed">
          Walk our show residences, explore the arrival courts and meet our design team. Personalised viewings on weekdays and weekends.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center mt-10">
          <Link to="/contact" className="btn-gold">Book a Visit <ArrowUpRight size={14} /></Link>
          <Link to="/projects" className="btn-ghost text-[#F5EFE6] border-[#F5EFE6] hover:bg-[#F5EFE6] hover:text-[#1F1B17]">Browse Projects</Link>
        </div>
      </div>
    </section>
  );
}
